// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inv-sett-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}
.inv-sett-section .inv-sett-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch.small {
  width: 40px;
  height: 22px;
}
.toggle-switch.small .toggle-slider:before {
  height: 18px;
  width: 18px;
}
.toggle-switch.small input:checked + .toggle-slider:before {
  transform: translateX(18px);
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.uploader-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;
}

.file-uploader {
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  background: #f9fafb;
  transition: all 0.3s ease;
}
.file-uploader:hover {
  border-color: #004A9A;
  background: #f8faff;
}
.file-uploader .uploader-label {
  display: block;
  font-weight: 600;
  color: #475569;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.upload-placeholder:hover {
  background: #e0e7ff;
  transform: translateY(-2px);
}
.upload-placeholder p {
  margin: 0.5rem 0 0 0;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
}

.upload-progress {
  text-align: center;
  padding: 1.5rem 1rem;
}
.upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.upload-progress .progress-bar .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #004A9A 0%, #0066cc 100%);
  transition: width 0.3s ease;
  border-radius: 4px;
}
.upload-progress p {
  margin: 0;
  font-size: 0.9rem;
  color: #475569;
  font-weight: 500;
}

.upload-success {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}
.upload-success .file-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
}
.upload-success .file-info .file-icon {
  font-size: 1.5rem;
  color: #004A9A;
}
.upload-success .file-info .file-name {
  font-weight: 500;
  color: #475569;
  font-size: 0.9rem;
  flex: 1 1;
}
.upload-success .file-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: end;
}
.upload-success .file-actions button {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.upload-success .file-actions button.view-btn {
  background: #004A9A;
  color: white;
  border-color: #004A9A;
}
.upload-success .file-actions button.view-btn:hover {
  background: #003a7a;
  transform: translateY(-1px);
}
.upload-success .file-actions button.change-btn {
  background: #f59e0b;
  color: white;
  border-color: #f59e0b;
}
.upload-success .file-actions button.change-btn:hover {
  background: #d97706;
  transform: translateY(-1px);
}
.upload-success .file-actions button.remove-btn {
  background: #ef4444;
  color: white;
  border-color: #ef4444;
}
.upload-success .file-actions button.remove-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.form-group-invoice-settings {
  margin-bottom: 1rem;
}
.form-group-invoice-settings label {
  display: block;
  font-weight: 500;
  color: #475569;
  padding-bottom: 0.5rem;
}
.form-group-invoice-settings input, .form-group-invoice-settings textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
  transition: all 0.3s ease;
}
.form-group-invoice-settings input:focus, .form-group-invoice-settings textarea:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.form-group-invoice-settings input::placeholder, .form-group-invoice-settings textarea::placeholder {
  color: #94a3b8;
}
.form-group-invoice-settings textarea {
  min-height: 80px;
  resize: vertical;
}

.tc-container {
  margin-top: 1rem;
}
.tc-container label {
  display: block;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}

.tc-rule-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.tc-rule-row .rule-number {
  font-weight: 500;
  color: #475569;
  min-width: 20px;
}
.tc-rule-row input {
  flex: 1 1;
  padding: 0.6rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9rem;
  background: #f9fafb;
}
.tc-rule-row input:focus {
  outline: none;
  border-color: #3a86ff;
}
.tc-rule-row .remove-rule-btn {
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  transition: background-color 0.2s;
}
.tc-rule-row .remove-rule-btn:hover {
  background: #dc2626;
}

.add-rule-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  transition: background-color 0.2s;
}
.add-rule-btn:hover {
  background: #004A9A;
}

.service-input-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.service-input-row input {
  flex: 1 1;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
}
.service-input-row input:focus {
  outline: none;
  border-color: #3a86ff;
}
.service-input-row .add-service-btn {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.service-input-row .add-service-btn:hover {
  background: #059669;
}

.services-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.service-item .service-name {
  font-weight: 500;
  color: #475569;
}
.service-item .remove-service-btn {
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  transition: background-color 0.2s;
}
.service-item .remove-service-btn:hover {
  background: #dc2626;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .inv-sett-section {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .uploader-group {
    grid-template-columns: 1fr;
  }
  .file-uploader .file-actions {
    flex-direction: column;
    gap: 0.75rem;
  }
  .file-uploader .file-actions button {
    width: 100%;
    padding: 0.75rem;
  }
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons button {
    width: 100%;
    padding: 1rem;
  }
  .tc-rule-row {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  .tc-rule-row .rule-number {
    min-width: auto;
  }
  .tc-rule-row input {
    width: 100%;
    min-width: 0;
  }
  .tc-rule-row .remove-rule-btn {
    align-self: flex-end;
  }
  .service-input-row {
    flex-direction: column;
  }
  .service-input-row .add-service-btn {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/InvoiceSettings/InvoiceSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAAF;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AADJ;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAFF;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;AAHJ;AAKI;EACE,YAAA;EACA,WAAA;AAHN;AAMI;EACE,2BAAA;AAJN;AAQE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AANJ;AAQI;EACE,yBAAA;AANN;AASI;EACE,2BAAA;AAPN;AAUI;EACE,2BAAA;AARN;AAYE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;AAYI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAVN;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAZF;;AAgBA;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAbF;AAeE;EACE,qBAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAfF;AAiBE;EACE,mBAAA;EACA,2BAAA;AAfJ;AAkBE;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,oBAAA;AAjBF;AAmBE;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,4DAAA;EACA,2BAAA;EACA,kBAAA;AAjBN;AAqBE;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AApBF;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,iBAAA;EACA,cAAA;AApBN;AAuBI;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;AArBN;AAyBE;EACE,aAAA;EACA,WAAA;EACA,oBAAA;AAvBJ;AAyBI;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;AAvBN;AAyBM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAvBR;AAyBQ;EACE,mBAAA;EACA,2BAAA;AAvBV;AA2BM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAzBR;AA2BQ;EACE,mBAAA;EACA,2BAAA;AAzBV;AA6BM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA3BR;AA6BQ;EACE,mBAAA;EACA,2BAAA;AA3BV;;AAkCA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA/BF;;AAkCA;EACE,mBAAA;AA/BF;AAiCE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhCN;AAmCI;EACE,cAAA;AAjCN;AAqCE;EACE,gBAAA;EACA,gBAAA;AAnCJ;;AAuCA;EACE,gBAAA;AApCF;AAsCE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AApCJ;;AAwCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AArCF;AAuCE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AArCJ;AAwCE;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAtCJ;AAwCI;EACE,aAAA;EACA,qBAAA;AAtCN;AA0CE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AAxCJ;AA0CI;EACE,mBAAA;AAxCN;;AA6CA;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AA1CF;AA4CE;EACE,mBAAA;AA1CJ;;AA8CA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA3CF;AA6CE;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,aAAA;EACA,qBAAA;AA3CN;AA+CE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA7CJ;AA+CI;EACE,mBAAA;AA7CN;;AAkDA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA/CF;AAiDE;EACE,gBAAA;EACA,cAAA;AA/CJ;AAkDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AAhDJ;AAkDI;EACE,mBAAA;AAhDN;;AAqDA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAlDF;AAoDE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAlDJ;AAoDI;EACE,mBAAA;AAlDN;AAsDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AApDJ;AAsDI;EACE,mBAAA;AApDN;AAuDI;EACE,mBAAA;EACA,mBAAA;AArDN;;AA2DA;EACE;IACE,aAAA;EAxDF;EA2DA;IACE,0BAAA;EAzDF;EA4DA;IACE,0BAAA;EA1DF;EA8DE;IACE,sBAAA;IACA,YAAA;EA5DJ;EA8DI;IACE,WAAA;IACA,gBAAA;EA5DN;EAiEA;IACE,sBAAA;EA/DF;EAiEE;IACE,WAAA;IACA,aAAA;EA/DJ;EAmEA;IACE,eAAA;IACA,YAAA;EAjEF;EAmEE;IACE,eAAA;EAjEJ;EAoEE;IACE,WAAA;IACA,YAAA;EAlEJ;EAqEE;IACE,oBAAA;EAnEJ;EAuEA;IACE,sBAAA;EArEF;EAuEE;IACE,gBAAA;EArEJ;AACF","sourcesContent":["// InvoiceSettings.scss\r\n.inv-sett-section {\r\n  padding: 2rem;\r\n  background: #f4f6f8;\r\n  color: #334155;\r\n  \r\n  .inv-sett-title {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 2rem;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.settings-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #e0e0e0;\r\n  \r\n  .card-title {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 1.2rem;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 1px solid #f1f1f1;\r\n  }\r\n}\r\n\r\n.toggle-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  \r\n  label {\r\n    font-weight: 500;\r\n    color: #475569;\r\n  }\r\n}\r\n\r\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 26px;\r\n  \r\n  &.small {\r\n    width: 40px;\r\n    height: 22px;\r\n    \r\n    .toggle-slider:before {\r\n      height: 18px;\r\n      width: 18px;\r\n    }\r\n    \r\n    input:checked + .toggle-slider:before {\r\n      transform: translateX(18px);\r\n    }\r\n  }\r\n  \r\n  input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n    \r\n    &:checked + .toggle-slider {\r\n      background-color: #004A9A;\r\n    }\r\n    \r\n    &:checked + .toggle-slider:before {\r\n      transform: translateX(24px);\r\n    }\r\n    \r\n    &:focus + .toggle-slider {\r\n      box-shadow: 0 0 1px #004A9A;\r\n    }\r\n  }\r\n  \r\n  .toggle-slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #c4c4c4;\r\n    transition: .4s;\r\n    border-radius: 34px;\r\n    \r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 22px;\r\n      width: 22px;\r\n      left: 2px;\r\n      bottom: 2px;\r\n      background-color: white;\r\n      transition: .4s;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.uploader-group {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n// File Uploader Styles\r\n.file-uploader {\r\n  border: 2px dashed #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n  background: #f9fafb;\r\n  transition: all 0.3s ease;\r\n  \r\n  &:hover {\r\n    border-color: #004A9A;\r\n    background: #f8faff;\r\n  }\r\n  \r\n  .uploader-label {\r\n    display: block;\r\n    font-weight: 600;\r\n    color: #475569;\r\n    margin-bottom: 1rem;\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n\r\n.upload-placeholder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem 1rem;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n  \r\n  &:hover {\r\n    background: #e0e7ff;\r\n    transform: translateY(-2px);\r\n  }\r\n  \r\n  p {\r\n    margin: 0.5rem 0 0 0;\r\n    color: #64748b;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.upload-progress {\r\n  text-align: center;\r\n  padding: 1.5rem 1rem;\r\n  \r\n  .progress-bar {\r\n    width: 100%;\r\n    height: 8px;\r\n    background-color: #e2e8f0;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    margin-bottom: 0.5rem;\r\n    \r\n    .progress-fill {\r\n      height: 100%;\r\n      background: linear-gradient(90deg, #004A9A 0%, #0066cc 100%);\r\n      transition: width 0.3s ease;\r\n      border-radius: 4px;\r\n    }\r\n  }\r\n  \r\n  p {\r\n    margin: 0;\r\n    font-size: 0.9rem;\r\n    color: #475569;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.upload-success {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  \r\n  .file-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    padding: 0.75rem;\r\n    background: #f0f9ff;\r\n    border: 1px solid #bae6fd;\r\n    border-radius: 8px;\r\n    \r\n    .file-icon {\r\n      font-size: 1.5rem;\r\n      color: #004A9A;\r\n    }\r\n    \r\n    .file-name {\r\n      font-weight: 500;\r\n      color: #475569;\r\n      font-size: 0.9rem;\r\n      flex: 1;\r\n    }\r\n  }\r\n  \r\n  .file-actions {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    justify-content: end;\r\n    \r\n    button {\r\n      padding: 0.5rem 1rem;\r\n      border-radius: 6px;\r\n      font-size: 0.85rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      border: 1px solid transparent;\r\n      \r\n      &.view-btn {\r\n        background: #004A9A;\r\n        color: white;\r\n        border-color: #004A9A;\r\n        \r\n        &:hover {\r\n          background: #003a7a;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n      \r\n      &.change-btn {\r\n        background: #f59e0b;\r\n        color: white;\r\n        border-color: #f59e0b;\r\n        \r\n        &:hover {\r\n          background: #d97706;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n      \r\n      &.remove-btn {\r\n        background: #ef4444;\r\n        color: white;\r\n        border-color: #ef4444;\r\n        \r\n        &:hover {\r\n          background: #dc2626;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.form-group-invoice-settings{\r\n  margin-bottom: 1rem;\r\n  \r\n  label {\r\n    display: block;\r\n    font-weight: 500;\r\n    color: #475569;\r\n    padding-bottom: 0.5rem;\r\n  }\r\n  \r\n  input, textarea {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    background: #f9fafb;\r\n    transition: all 0.3s ease;\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3a86ff;\r\n      box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\r\n    }\r\n    \r\n    &::placeholder {\r\n      color: #94a3b8;\r\n    }\r\n  }\r\n  \r\n  textarea {\r\n    min-height: 80px;\r\n    resize: vertical;\r\n  }\r\n}\r\n\r\n.tc-container {\r\n  margin-top: 1rem;\r\n  \r\n  label {\r\n    display: block;\r\n    font-weight: 500;\r\n    color: #475569;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n}\r\n\r\n.tc-rule-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n  \r\n  .rule-number {\r\n    font-weight: 500;\r\n    color: #475569;\r\n    min-width: 20px;\r\n  }\r\n  \r\n  input {\r\n    flex: 1;\r\n    padding: 0.6rem 0.75rem;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 6px;\r\n    font-size: 0.9rem;\r\n    background: #f9fafb;\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3a86ff;\r\n    }\r\n  }\r\n  \r\n  .remove-rule-btn {\r\n    background: #ef4444;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    width: 28px;\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    transition: background-color 0.2s;\r\n    \r\n    &:hover {\r\n      background: #dc2626;\r\n    }\r\n  }\r\n}\r\n\r\n.add-rule-btn {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  margin-top: 0.5rem;\r\n  transition: background-color 0.2s;\r\n  \r\n  &:hover {\r\n    background: #004A9A;\r\n  }\r\n}\r\n\r\n.service-input-row {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  \r\n  input {\r\n    flex: 1;\r\n    padding: 0.75rem;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    background: #f9fafb;\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3a86ff;\r\n    }\r\n  }\r\n  \r\n  .add-service-btn {\r\n    background: #10b981;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 0 1rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    \r\n    &:hover {\r\n      background: #059669;\r\n    }\r\n  }\r\n}\r\n\r\n.services-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.service-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.75rem;\r\n  background: #f9fafb;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  \r\n  .service-name {\r\n    font-weight: 500;\r\n    color: #475569;\r\n  }\r\n  \r\n  .remove-service-btn {\r\n    background: #ef4444;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    width: 26px;\r\n    height: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    transition: background-color 0.2s;\r\n    \r\n    &:hover {\r\n      background: #dc2626;\r\n    }\r\n  }\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #e2e8f0;\r\n  \r\n  .cancel-btn {\r\n    background: #f1f1f1;\r\n    color: #475569;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    \r\n    &:hover {\r\n      background: #e2e8f0;\r\n    }\r\n  }\r\n  \r\n  .save-btn {\r\n    background: #004A9A;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    \r\n    &:hover:not(:disabled) {\r\n      background: #003a7a;\r\n    }\r\n    \r\n    &:disabled {\r\n      background: #c4c4c4;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive adjustments\r\n@media (max-width: 768px) {\r\n  .inv-sett-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .form-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .uploader-group {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .file-uploader {\r\n    .file-actions {\r\n      flex-direction: column;\r\n      gap: 0.75rem;\r\n      \r\n      button {\r\n        width: 100%;\r\n        padding: 0.75rem;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: column;\r\n    \r\n    button {\r\n      width: 100%;\r\n      padding: 1rem;\r\n    }\r\n  }\r\n  \r\n  .tc-rule-row {\r\n    flex-wrap: wrap;\r\n    gap: 0.75rem;\r\n    \r\n    .rule-number {\r\n      min-width: auto;\r\n    }\r\n    \r\n    input {\r\n      width: 100%;\r\n      min-width: 0;\r\n    }\r\n    \r\n    .remove-rule-btn {\r\n      align-self: flex-end;\r\n    }\r\n  }\r\n  \r\n  .service-input-row {\r\n    flex-direction: column;\r\n    \r\n    .add-service-btn {\r\n      padding: 0.75rem;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
